import { TypographyColor } from 'melp-design/components';
import { AdminStatus } from './admin-admins.types';

export const COLOR_BY_STATUS: Record<AdminStatus, TypographyColor> = {
  active: 'success',
  inactive: 'textSecondary',
};
